import { Check, CheckCircle2, Clock, Hourglass } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { getConfirmationState } from './helper';

const SOFT_BASE =
  'inline-flex items-center gap-1 text-[11px] font-semibold px-2.5 py-1 rounded-md uppercase';
const PILL_BASE =
  'inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full';

export const ConfirmationBadge = ({ appt, variant = 'soft', className = '', iconSize = 12 }) => {
  const state = getConfirmationState(appt);

  // Cancelled appointments: confirmation isn't applicable. Show an em-dash placeholder.
  if (state === 'not-applicable') {
    return <div className="flex justify-center text-secondary-400">—</div>;
  }

  if (state === 'confirmed') {
    const Icon = variant === 'pill' ? Check : CheckCircle2;
    const base = variant === 'pill' ? PILL_BASE : SOFT_BASE;
    const iconProps = variant === 'pill' ? { strokeWidth: 3 } : {};
    return (
      <span className={twMerge(`${base} bg-green-50 text-green-700`, className)}>
        <Icon size={iconSize} {...iconProps} />
        Confirmed
      </span>
    );
  }

  // Patient already submitted a confirm request — office is reviewing it.
  // Blue tone (vs amber for plain "Pending") signals "in flight with the
  // office" rather than "patient hasn't acted yet".
  if (state === 'pending-request') {
    return (
      <span className={twMerge(`${SOFT_BASE} bg-blue-50 text-blue-700`, className)}>
        <Hourglass size={iconSize} />
        Pending request
      </span>
    );
  }

  // 'pending' — nothing has happened yet.
  return (
    <span className={twMerge(`${SOFT_BASE} bg-amber-50 text-amber-700`, className)}>
      <Clock size={iconSize} />
      Pending
    </span>
  );
};
